<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="paymentTypeAudits && paymentTypeAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="paymentTypeAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Payment Type audits </ng-template>
</ng-template>
